"use client";

import { ChartOptions, TooltipItem } from "chart.js";
import { isDesktop } from "react-device-detect";

import { Translation } from "@/data/lang";

export const getChipComboChartOptions = ({
  t,
}: {
  t: Translation;
}): ChartOptions<"bar"> => ({
  aspectRatio: !isDesktop ? 1 : 2,
  scales: {
    x: {
      grid: { display: false },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      padding: 10,
      boxPadding: 10,
      itemSort: (a, b) => sortTooltipItems(a, b, t),
      usePointStyle: true,
    },
  },
  interaction: {
    intersect: false,
    mode: "index",
  },
});

const sortTooltipItems = (
  a: TooltipItem<"bar">,
  b: TooltipItem<"bar">,
  t: Translation
) => {
  if (a.dataset.label === t.analysis.chip.institutionalInvestors.price)
    return 1;
  if (b.dataset.label === t.analysis.chip.institutionalInvestors.price)
    return -1;
  return 0;
};
